const TIMESTAMP_PREFIX_REGEX = /^(\d{10,14})_(.+)$/;

const decodeFromUrl = (url = "") => {
  if (!url) return "";
  try {
    const clean = url.split("?")[0] || "";
    const lastSegment = clean.split("/").pop() || "";
    return decodeURIComponent(lastSegment);
  } catch {
    return "";
  }
};

const stripTimestampPrefix = (name = "") => {
  if (!name) return "";
  const match = name.match(TIMESTAMP_PREFIX_REGEX);
  if (match && match[2]) {
    return match[2];
  }
  return name;
};

export const normalizeFileName = (
  rawName,
  mediaUrl,
  fallback = "arquivo"
) => {
  const trimmed = (rawName || "").trim();
  if (trimmed) {
    const cleaned = stripTimestampPrefix(trimmed);
    if (cleaned) {
      return cleaned;
    }
  }

  const fromUrl = decodeFromUrl(mediaUrl);
  if (fromUrl) {
    const cleaned = stripTimestampPrefix(fromUrl);
    if (cleaned) {
      return cleaned;
    }
  }

  return fallback;
};

export const getExtensionFromName = (fileName = "") => {
  if (!fileName) return "";
  const parts = fileName.split(".");
  if (parts.length > 1) {
    return parts.pop().toLowerCase();
  }
  return "";
};

export const guessExtensionFromMime = (mime = "") => {
  if (!mime) return "";
  const [type, subtypeRaw] = mime.split("/");
  if (!subtypeRaw) return "";
  let subtype = subtypeRaw.split(";")[0];
  subtype = subtype.split("+")[0];

  if (type === "image" && subtype === "jpeg") {
    return ".jpg";
  }

  if (subtype) {
    return `.${subtype}`;
  }

  return "";
};

export const ensureFileNameHasExtension = (fileName, mimeType = "") => {
  if (!fileName) return fileName;
  if (getExtensionFromName(fileName)) {
    return fileName;
  }
  const extension = guessExtensionFromMime(mimeType);
  if (!extension) {
    return fileName;
  }
  return `${fileName}${extension}`;
};
